(function() {
  "use strict";

  // ─── Image Gallery ────────────────────────────────────────────

  var mainImageWrap = document.getElementById("hw-main-image");
  var mainImg = mainImageWrap ? mainImageWrap.querySelector("img") : null;
  var thumbs = document.querySelectorAll(".hw-pdp__thumb");

  thumbs.forEach(function(thumb) {
    thumb.addEventListener("click", function() {
      var src = this.dataset.src;
      var full = this.dataset.full;
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.dataset.full = full || src;
      }
      thumbs.forEach(function(t) { t.classList.remove("active"); });
      this.classList.add("active");
    });
  });

  // ─── Lightbox ─────────────────────────────────────────────────

  var lightbox = document.getElementById("hw-lightbox");
  if (lightbox && mainImageWrap) {
    var lbImg = lightbox.querySelector("img");
    var lbClose = lightbox.querySelector(".hw-pdp__lightbox-close");

    mainImageWrap.addEventListener("click", function() {
      if (mainImg && lbImg) {
        lbImg.src = mainImg.dataset.full || mainImg.src;
        lbImg.alt = mainImg.alt;
        lightbox.classList.add("active");
      }
    });

    lightbox.addEventListener("click", function(e) {
      if (e.target === lightbox || e.target === lbClose) {
        lightbox.classList.remove("active");
      }
    });

    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && lightbox.classList.contains("active")) {
        lightbox.classList.remove("active");
      }
    });
  }

  // ─── Tabs ─────────────────────────────────────────────────────

  var tabBtns = document.querySelectorAll(".hw-pdp__tab-btn");
  var tabPanels = document.querySelectorAll(".hw-pdp__tab-panel");

  tabBtns.forEach(function(btn) {
    btn.addEventListener("click", function() {
      var target = this.dataset.tab;

      tabBtns.forEach(function(b) {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });
      tabPanels.forEach(function(p) { p.classList.remove("active"); });

      this.classList.add("active");
      this.setAttribute("aria-selected", "true");

      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add("active");
    });
  });

  // ─── Quantity Buttons ─────────────────────────────────────────

  var qtyInput = document.getElementById("Quantity");
  var qtyMinus = document.querySelector(".hw-qty-minus");
  var qtyPlus = document.querySelector(".hw-qty-plus");

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener("click", function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener("click", function() {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }
})();
